import { render, staticRenderFns } from "./SelectorTags.vue?vue&type=template&id=7d8d6c2e&scoped=true&"
import script from "./SelectorTags.vue?vue&type=script&lang=js&"
export * from "./SelectorTags.vue?vue&type=script&lang=js&"
import style0 from "./SelectorTags.vue?vue&type=style&index=0&id=7d8d6c2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8d6c2e",
  null
  
)

export default component.exports